import {appAPI} from "../../../api";
import {
    IAcceptConsentData,
    IConsentStatus,
    ICookieAcceptData,
    ILegalDocument,
    ILegalVersions,
    LegalDocumentType,
} from "../model/types";

const versionsPath = `/legal/versions`;
const documentPath = (type: LegalDocumentType) => `/legal/documents/${type}`;
const statusPath = `/legal/consent/status`;
const acceptPath = `/legal/consent/accept`;
const withdrawPath = `/legal/consent/withdraw`;
const cookieAcceptPath = `/legal/cookie/accept`;

export const legalAPI = {
    /** Публично: текущие номера версий (для форм регистрации). */
    getVersions: async (): Promise<ILegalVersions> => {
        const res = await appAPI.get(versionsPath);
        return res.data;
    },
    /** Публично: документ с телом. */
    getDocument: async (type: LegalDocumentType): Promise<ILegalDocument> => {
        const res = await appAPI.get(documentPath(type));
        return res.data;
    },
    getStatus: async (): Promise<IConsentStatus> => {
        const res = await appAPI.get(statusPath);
        return res.data;
    },
    accept: async (data: IAcceptConsentData) => {
        const res = await appAPI.post(acceptPath, data);
        return res.data;
    },
    withdraw: async () => {
        const res = await appAPI.post(withdrawPath);
        return res.data;
    },
    cookieAccept: async (data: ICookieAcceptData) => {
        const res = await appAPI.post(cookieAcceptPath, data);
        return res.data;
    },
};
